// extracted by css-extract-rspack-plugin
export default {"menuBtn":"Sidebar__menuBtn--ppthN","fixation":"Sidebar__fixation--yKXF9","notHaveJobcanHeader":"Sidebar__notHaveJobcanHeader--isM5i"};